import React, { Fragment } from 'react';
import { SettingsContainer, Input, InputLabel, Select } from '../style';
import { Text } from '../../../../UI/Text';
import { OuterIndent, Row } from '../../../../Layouts';
import { SettingsPreviewItem } from './SettingsPreviewItem';
import { modalTypes } from '../constants';
import { BackgroundPreview } from './BackgroundPreview';
import { BackgroundInput } from './BackgroundInput';
import { Checkbox } from './CheckBox';
import NewDurationPicker from '../../../../Components/Pickers/NewTimePicker';

const getRoomNumberOptions = () =>
    [...Array(10)].map((item, index) => {
        if (index === 0) return { value: index, label: 'None' };
        else return { value: index, label: index };
    });

export const Settings = ({
    name,
    handleInputChange,
    handleCheck,
    handleDurationChange,
    openSelectModal,
    deleteDisplayItem,
    openBetweenModal,
    layer,
    wifi_name,
    wifi_password,
    room_number,
    rotation_duration,
    after,
    during,
    before,
    between,
    background_preview,
    background,
    uploadBackgroundImage,
    id,
}) => {
    return (
        <SettingsContainer>
            {id && (
                <Fragment>
                    <OuterIndent indent={'0 0 10px 0'}>
                        <Text weight={'bold'} fontSize={24}>
                            {name}
                        </Text>
                    </OuterIndent>

                    {/* Default settings */}
                    <OuterIndent indent={'5px 0'}>
                        <Text weight={'bold'} opacity={0.8} fontSize={18}>
                            Default
                        </Text>
                    </OuterIndent>

                    {background && (
                        <OuterIndent indent={'4px 0'}>
                            <BackgroundPreview
                                value={background}
                                background={background_preview}
                                onChange={uploadBackgroundImage}
                                name={'background'}
                                isDarkeningLayerApplied={layer}
                            />
                        </OuterIndent>
                    )}

                    <OuterIndent indent={'4px 0'}>
                        <Text weight={'bold'} opacity={0.8} fontSize={12}>
                            Default background image
                        </Text>
                    </OuterIndent>

                    <OuterIndent indent={'4px 0'}>
                        <Text opacity={0.5} weight={100} fontSize={12}>
                            Recommended: 2560 pixels x 1440 pixels
                        </Text>
                    </OuterIndent>

                    <OuterIndent indent={'8px 0'}>
                        <Row align={'center'}>
                            {!background && (
                                <OuterIndent indent={'0 8px 0 0'}>
                                    <BackgroundInput name={'background'} onChange={uploadBackgroundImage} />
                                </OuterIndent>
                            )}

                            {/* <OuterIndent indent={'0 8px 0 0'}> */}
                            <Checkbox
                                checked={layer}
                                name={'layer'}
                                onChange={handleCheck}
                                label={'Add darkening layer'}
                            />
                            {/* </OuterIndent> */}
                        </Row>
                    </OuterIndent>

                    {/* Public wi-fi */}
                    <OuterIndent indent={'16px 0'}>
                        <OuterIndent indent={'0 0 4px 0'}>
                            <InputLabel>Public Wifi</InputLabel>
                            <Input
                                onChange={handleInputChange}
                                name={'wifi_name'}
                                placeholder={'Public wifi'}
                                value={wifi_name}
                            />
                        </OuterIndent>

                        <OuterIndent indent={'12px 0 8px 0'}>
                            <InputLabel>Public Wifi Password</InputLabel>
                            <Input
                                onChange={handleInputChange}
                                name={'wifi_password'}
                                placeholder={'Public wifi password'}
                                value={wifi_password}
                            />
                        </OuterIndent>
                        <Text weight={100} opacity={0.5} fontSize={11}>
                            So members can join leaderboards live
                        </Text>
                    </OuterIndent>

                    {/* Specific settings */}
                    <OuterIndent indent={'40px 0 0 0'}>
                        <OuterIndent indent={'0 0 12px 0'}>
                            <Text weight={'bold'} opacity={0.8} fontSize={18}>
                                Live class TV
                            </Text>
                        </OuterIndent>

                        <OuterIndent indent={'0 0 12px 0'}>
                            <InputLabel>Sync to schedule</InputLabel>
                            <Select name={'room_number'} onChange={handleInputChange} value={room_number}>
                                {getRoomNumberOptions().map((item, index) => (
                                    <option key={index} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </Select>
                        </OuterIndent>

                        <OuterIndent indent={'22px 0'}>
                            <SettingsPreviewItem
                                onAction={openSelectModal.bind(this, modalTypes.BEFORE_CLASS)}
                                onDelete={deleteDisplayItem.bind(this, modalTypes.BEFORE_CLASS, before.data)}
                                title={'Before class'}
                                item={before.data}
                            />
                        </OuterIndent>

                        <OuterIndent indent={'22px 0'}>
                            <SettingsPreviewItem
                                onAction={openSelectModal.bind(this, modalTypes.DURING_CLASS)}
                                onDelete={deleteDisplayItem.bind(this, modalTypes.DURING_CLASS, during.data)}
                                title={'During class'}
                                item={during.data}
                            />
                        </OuterIndent>

                        <OuterIndent indent={'22px 0'}>
                            <SettingsPreviewItem
                                onAction={openSelectModal.bind(this, modalTypes.AFTER_CLASS)}
                                onDelete={deleteDisplayItem.bind(this, modalTypes.AFTER_CLASS, after.data)}
                                title={'Display after class'}
                                item={after.data}
                            />
                        </OuterIndent>
                    </OuterIndent>

                    <OuterIndent style={{ width: '100%' }} indent={'40px 0 0 0'}>
                        <OuterIndent indent={'0 0 12px 0'}>
                            <Text weight={'bold'} opacity={0.8} fontSize={18}>
                                Between classes
                            </Text>
                        </OuterIndent>

                        <OuterIndent indent={'0 0 12px 0'}>
                            <InputLabel>Rotate screens every</InputLabel>
                            {/* <Input name={'rotation_duration'} value={rotation_duration} onChange={handleInputChange} /> */}
                            <NewDurationPicker initial={rotation_duration} passData={handleDurationChange} />
                        </OuterIndent>

                        {between.data &&
                            between.data.map((betweenItem, index) => (
                                <OuterIndent key={index} indent={'22px 0'}>
                                    <SettingsPreviewItem
                                        onAction={openSelectModal.bind(this, modalTypes.BETWEEN_CLASSES, index)}
                                        onDelete={deleteDisplayItem.bind(
                                            this,
                                            modalTypes.BETWEEN_CLASSES,
                                            between.data[index],
                                            index,
                                        )}
                                        item={betweenItem}
                                    />
                                </OuterIndent>
                            ))}

                        <SettingsPreviewItem
                            onAction={openSelectModal.bind(
                                this,
                                modalTypes.BETWEEN_CLASSES,
                                between.data ? between.data.length : 0,
                            )}
                        />
                    </OuterIndent>
                </Fragment>
            )}
        </SettingsContainer>
    );
};

Settings.defaultProps = {
    handleInputChange: () => {},
    wifi_name: '',
    wifi_password: '',
    name: 'Select an item',
    isDarkeningLayerApplied: false,
    before: {},
    after: {},
    during: {},
    between: {},
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/Settings/Settings.js